<script>
  import { onDestroy, createEventDispatcher } from 'svelte';

  import { getGroupStore } from '@stores/group';
  let recObjectsStore = getGroupStore('recObjectsStore');

  import MobileMap from '@app-components/group/MobileMap.svelte';
  import MobileGoToListButton from '@app-components/group/MobileGoToListButton.svelte';

  export let group;
  export let isSignedInUser;
  export let loaded;
  export let searchMode = false;
  export let customClickHandler;
  export let setViewportAutomatically;

  let recObjects = recObjectsStore;
  const unsubRecObjects = recObjectsStore.subscribe((x) => (recObjects = x));
  const getGeodata = (recObject) => recObject.addresses[0]?.geodata || {};

  $: recObjectsWithLocation = recObjects.filter((recObject) => getGeodata(recObject).location);

  const dispatch = createEventDispatcher();

  const dispatchListButtonClicked = (_e) => {
    dispatch('leave-map-view');
  };

  onDestroy(() => {
    unsubRecObjects();
  });
</script>

<style style="text/scss" lang="scss">
  $header-height: 70px;
  $footer-height: 64px;

  .m-map-view {
    margin: 0px -30px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
    height: calc(100vh - $header-height);

    .m-map-view__group-name {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      margin-left: 30px;
      margin-right: 30px;
      margin-top: 20px;

      .m-map-view__group-title {
        font-size: 15px;
        font-weight: 500;
        text-align: left;
      }

      .m-map-view__group-recs-count {
        flex-shrink: 0;
        display: flex;
        margin-left: 18px;

        img {
          width: 15px;
          height: 15px;
        }
        span {
          margin-left: 8px;
          font-size: 14px;
          opacity: 0.5;
        }
      }
    }

    .m-map-view__map {
      flex-grow: 1;
      text-align: center;
    }

    &.with-footer {
      height: calc(100vh - $header-height - $footer-height);
    }
  }
</style>

<div class="m-map-view" class:with-footer={isSignedInUser}>
  {#if loaded}
    {#if !searchMode}
      <div class="m-map-view__group-name">
        <div class="m-map-view__group-title">
          {group.name}
        </div>

        <span class="m-map-view__group-recs-count">
          <img alt="section" src="/emojis/purple_star.png" class="group-recs-count__image" />
          <span>
            {recObjectsWithLocation.length} of {recObjects.length}
          </span>
        </span>
      </div>
    {/if}

    <div class="m-map-view__map">
      <MobileMap
        on:init-map={(e) => dispatch('init-map', e.detail)}
        withFooter={isSignedInUser}
        searchMode={searchMode}
        customClickHandler={customClickHandler}
        bind:setViewportAutomatically={setViewportAutomatically} />
    </div>

    {#if !searchMode}
      <MobileGoToListButton on:click={dispatchListButtonClicked} />
    {/if}
  {/if}
</div>
